import React, { createContext, useContext, useEffect, useState } from 'react'
import { fetchData, startPolling } from '../../../reusable'

interface PermissionContextType {
  permissions: string[]
  refreshPermissions: () => void
}

const PermissionContext = createContext<PermissionContextType>({
  permissions: [],
  refreshPermissions: () => { },
})

export const usePermissions = () => useContext(PermissionContext)

export const PermissionProvider = ({ children }: { children: React.ReactNode }) => {
  const [permissions, setPermissions] = useState<string[]>([])
  let adminData: any = sessionStorage.getItem('admin')
  let adminId = ''
  let isSuperAdmin = ''
  if (adminData) {
    adminId = JSON.parse(adminData).adminId
    isSuperAdmin = JSON.parse(adminData).mainadminId
  } else {
    adminId = ''
  }

  const profileDetailsApiCall = async () => {
    const param = {
      adminId: adminId,
    }
    const response: any = await fetchData('admin/viewProfile', param)

    if (String(response?.status) === '200') {
      const data = response.data[0]
      await roleDetailApiCall(data.roleId)
    }
  }

  const roleDetailApiCall = async (roleId: any) => {
    const param = { roleId }
    const response: any = await fetchData('admin/viewrole', param)

    if (String(response?.status) === '200') {
      const data = response.data[0]
      setPermissions(data) // update context
    }
  }

  // useEffect(() => {
  //   profileDetailsApiCall()
  //   const interval = setInterval(() => {
  //     if(document.visibilityState === 'visible') {

  //       profileDetailsApiCall() // auto-refresh every 10s
  //     }
  //   }, 60000)

  //   return () => clearInterval(interval)
  // }, [])

  // useEffect(() => {
  //     const { start, cleanup } = startPolling(profileDetailsApiCall, 15000);
  //     start();

  //     return () => cleanup(); // cleanup on unmount
  //   }, []);

  //  useEffect(() => {
  //     const stopPolling = startPolling(() => {
  //       profileDetailsApiCall()
  //     }, 180000); // 3 minutes

  //     return () => stopPolling(); // cleanup on unmount
  //   }, []);

  useEffect(() => {
    if(!adminId) return
    // Start interval
      profileDetailsApiCall();

    const intervalId = setInterval(() => {
      profileDetailsApiCall();
    }, 180000); // runs every 3 minutes

    // Cleanup function — this runs when the component unmounts
    return () => {
      clearInterval(intervalId);
    };
  }, []); // ✅ Empty dependency = runs only once

  return (
    <PermissionContext.Provider value={{ permissions, refreshPermissions: profileDetailsApiCall }}>
      {children}
    </PermissionContext.Provider>
  )
}
